// extracted by mini-css-extract-plugin
export var flowchartContainer = "_o-0";